import { RadioGroup, Radio } from '@vtex/admin-ui-form'
import { useDrawerSubForm } from 'hooks'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { FirstPurchase, FirstPurchaseLogin } from 'typings'
import {
  CancelButton,
  DismissButton,
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerSubtitle,
  DrawerTitle,
  SaveButton,
  UseDrawerStateReturn,
} from '../../../Drawer'
import { RadioDescription } from '../../../Radio/RadioDescription'
import { GroupLabel } from '../../../GroupLabel'
import { messages } from './messages'
import { styles } from './styles'

interface Props {
  state: UseDrawerStateReturn
  initialConfig: FirstPurchase | undefined
  onSave: (config: FirstPurchase | undefined) => void
}

const EMPTY_CONFIG: FirstPurchase = Object.freeze({
  login: FirstPurchaseLogin.OPTIONAL,
})

export function FirstPurchaseEditor(props: Props) {
  const { state, initialConfig, onSave } = props
  const { hide } = state

  const { $t } = useIntl()

  const config = useMemo(
    () => initialConfig ?? { ...EMPTY_CONFIG },
    [initialConfig]
  )

  const { drawerForm } = useDrawerSubForm<FirstPurchase>({
    config,
    isOpen: state.open,
  })

  const isCreating = !initialConfig

  const handleSave = () => {
    const values = drawerForm.getValues()
    onSave(values)
    hide()
  }

  return (
    <Drawer state={state}>
      <DrawerHeader>
        <DrawerTitle>{$t(messages.title)}</DrawerTitle>
        <DrawerSubtitle>{$t(messages.subtitle)}</DrawerSubtitle>
        <DismissButton onHide={state.hide} />
      </DrawerHeader>
      <DrawerContent>
        <RadioGroup
          name="login"
          label={<GroupLabel>{$t(messages.editor.radioGroup)}</GroupLabel>}
          state={drawerForm}
          className={styles.radioGroup}
        >
          {Object.values(FirstPurchaseLogin).map((value) => (
            <Radio
              key={value}
              aria-label={$t(messages.login[value].title)}
              label={
                <RadioDescription
                  title={$t(messages.login[value].title)}
                  description={$t(messages.login[value].description)}
                />
              }
              value={value}
            />
          ))}
        </RadioGroup>
      </DrawerContent>
      <DrawerFooter>
        <CancelButton onClick={hide} />
        <SaveButton isCreating={isCreating} onClick={handleSave} />
      </DrawerFooter>
    </Drawer>
  )
}
